import http from '../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/mubiao',
    baseurl2: '/api/swyl/v1',

    //目标列表
    page(query) {
        return http({
            url: this.baseurl + '/userDailyTarget/newSelectPage',
            method: 'post',
            params: query
        });
    },

    getDeptList(query) {
        return http({
            url: this.baseurl + '/userDailyTarget/selectDept',
            method: 'post',
            params: query
        });
    },
    getQuyuList(query) {
        return http({
            url: this.baseurl + '/userDailyTarget/selectarea',
            method: 'post',
            params: query
        });
    },

    getQudaoList(query) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/selectQudao',
            method: 'post',
            params: query
        });
    },

    getWeekList(query) {
        return http({
            url: this.baseurl + '/userDailyTarget/getWeekList',
            method: 'post',
            params: query
        });
    },
    saveOrUpdate(query) {
        return http({
            url: this.baseurl + '/userDailyTarget/saveOrUpdate',
            method: 'post',
            data: query
        });
    },
    selectById(query) {
        return http({
            url: this.baseurl + '/userDailyTarget/selectById',
            method: 'post',
            params: query
        });
    },
    getClearPlanById(query) {
        return http({
            url: this.baseurl + '/userDailyTarget/getClearPlanById',
            method: 'post',
            params: query
        });
    },

    del(query) {
        return http({
            url: this.baseurl + '/userDailyTarget/deleteById',
            method: 'post',
            params: query
        });
    },
    tzGrade(query) {
        return http({
            url: this.baseurl + '/userDailyTarget/tzGrade',
            method: 'post',
            data: query
        });
    },
    getProject(query) {
        return http({
            ///api/swyl/v1/mubiao/userDailyTargetProject/selectProList?projectName=
            url: this.baseurl + '/userDailyTargetProject/selectProList?projectName=',
            method: 'post',
            data: query
        });
    },

    getProjectChild(query) {
        return http({
            url: this.baseurl + '/userDailyTargetProject/selectProChildList?projectName='+query,
            method: 'post',
        });
    },

    getUser(query) {
        return http({
            ///api/swyl/v1/mubiao/userDailyTargetProject/selectProList?projectName=
            url: this.baseurl2 + '/dailyClear/userDailyClear/getCustomer?userName=' + query,
            method: 'post',
            //data: query
        });
    },
    getcust(query) {
        return http({
            url: '/api/swyl/v1/dailyClear/userDailyClear/getCust',
            method: 'post',
            data: query
        });
    },
    getUserLoud(query) {
        return http({
            url: this.baseurl2 + '/basic/bscAddrData/selectByName?name=' + query,
            method: 'post',
        });
    },
    customerCarryPerson(query) {
        return http({
            url: this.baseurl2 + '/loudnew/loudMain/customerCarryPerson?customerName=' + query,
            method: 'post',
        });
    },
    showPackPromode (query) {
        return http({
            url: this.baseurl2 + '/loudnew/loudMain/showpackpromode?id=' + query,
            method: 'post',
        });
    },
    //--------------------------日计划部分--------------------
    getLxr(query) {
        return http({
            url: '/api/swyl/v1/guanhuai/bscContactPerson/selectDataByCust?custName=' + query,
            method: 'post',
            params: query//?custName=测试11231231231
            //data: query
        });
    },
    selectPage(query) {
        return http({
            ///api/swyl/v1/mubiao/userDailyTargetProject/selectProList?projectName=
            url: this.baseurl2 + '/dailyClear/userDailyClear/selectPage',
            method: 'post',
            params: query
        });
    },
    checkPage(query) {
        return http({
            ///api/swyl/v1/mubiao/userDailyTargetProject/selectProList?projectName=
            url: this.baseurl2 + '/dailyClear/userDailyClear/checkPage',
            method: 'post',
            params: query
        });
    },

    clearPlanAddPage(query) {
        return http({
            url: this.baseurl2 + '/dailyClear/userDailyClear/selectPlanPage',
            method: 'post',
            params: query
        });
    },

    getDayClearPlan(query) {
        return http({
            url: this.baseurl2 + '/dailyClear/userDailyClear/getDayClearPlanPage',
            method: 'post',
            params: query
        });
    },

    getClearAppraisal(query) {
        return http({
            url: this.baseurl2 + '/guanhuai/userDailyClearAppraisal/selectPage',
            method: 'post',
            params: query
        });
    },

    delById(query) {
        return http({
            url: this.baseurl2 + '/dailyClear/userDailyClear/delById?id=' + query,
            method: 'post',
            //data: query
        });
    },

    deleteById(query) {
        return http({
            url: this.baseurl2 + '/guanhuai/bscContactPerson/delete?id=' + query,
            method: 'post',
            //data: query
        });
    },


    checkPunchPage(query) {
        return http({
            url: this.baseurl2 + '/dailyClear/userDailyClear/checkPunchPage',
            method: 'post',
            params: query
        });
    },

    canDailyClear(query) {
        return http({
            url: this.baseurl2 + '/dailyClear/userDailyClear/canDailyClear',
            method: 'post',
            params: query
        });
    },


    getListPlan(query) {
        return http({
            url: this.baseurl + '/userDailyTarget/selectDetailList',
            method: 'post',
            params: query
        });
    },
    insertAll(query) {
        return http({

            url: this.baseurl2 + '/dailyClear/userDailyClear/insertAll',
            method: 'post',
            data: query
        });
    },
    //联系人插入
    insertbcp(query) {
        return http({
            //  /api/swyl/v1/guanhuai/bscContactPerson
            url: this.baseurl2 + '/guanhuai/bscContactPerson/saveOrUpdate',
            method: 'post',
            data: query
        });
    },
    //单个查询
    getDailyPlanSingle(query) {
        return http({
            url: this.baseurl2 + '/dailyClear/userDailyClear/getDailyPlan?id=' + query,
            method: 'post',
            //data: query
        });
    },
    //线索管理修改查询单个
    getbscConcactpersonSingle(query) {
        return http({
            url: this.baseurl2+'/guanhuai/bscClueManage/selectById?id=' + query,
            method: 'post',
            //data: query
        });
    },

    //催办
    press(query) {
        return http({
            url: this.baseurl2+'/guanhuai/bscClueManage/pressId',
            method: 'post',
            params: query
        });
    },
    //批量催办
    batchpress(query) {
        return http({
            url: this.baseurl2+'/guanhuai/bscClueManage/batchpressId',
            method: 'post',
            data: query
        });
    },

    //联系人修改查询单个
    getbscConcactpersonSinglep(query) {
        return http({
            url: this.baseurl2 + '/guanhuai/bscContactPerson/selectById?id=' + query,
            method: 'post',
            //data: query
        });
    },


    getBsccone(query) {
        return http({
            url: this.baseurl2 + '/guanhuai/bscContactPerson/selectById?id=' + query,
            method: 'post',
            //data: query
        });
    },

    //修改提交
    updateById(query) {
        return http({
            url: this.baseurl2 + '/dailyClear/userDailyClear/updateById',
            method: 'post',
            data: query
        });
    },
    //url:'api/swyl/v1/dailyClear/userDailyClear/updateById',
    //url:'/api/swyl/v1/dailyClear/userDailyClear/getDailyPlan?id='+ id,
    //url:'/api/swyl/v1/dailyClear/userDailyClear/delById?id='+ id ,
    //目标列表
    pageCK(query) {
        return http({
            url: this.baseurl + '/userDailyTarget/newSelectCKPage',
            method: 'post',
            params: query
        });
    },
    saveOrUpdateCk(query) {
        return http({
            url: this.baseurl + '/userDailyTarget/saveOrUpdateCk',
            method: 'post',
            params: query
        });
    },
    submitDaily(query) {
        return http({
            url: this.baseurl2 + '/dailyClear/userDailyClear/submitDaily',
            method: 'post',
            data: query
        });
    },
    updatePlanAdd(query) {
        return http({
            url: this.baseurl2 + '/dailyClear/userDailyClear/updatePlanAdd',
            method: 'post',
            data: query
        });
    },

    //网络对阵


    //周计划汇总查询
    getColletWeek(query) {
        return http({
            url: '/api/swyl/v1/mubiao/userDailyTargetCollect/getCollectPage',
            method: 'post',
            params: query
        });
    },

    //周目标明细
    getSummaryWeek(query) {
        return http({
            url: '/api/swyl/v1/mubiao/userDailyTargetSummary/getSummaryPage',
            method: 'post',
            params: query
        });
    },
    getWsDifference(query) {
        return http({
            url: '/api/swyl/v1/mubiao/userResDistinction/selectResDistinctionPage',
            method: 'post',
            params: query,
        })
    },
    //联系人查询
    getBsccontactperson(query) {
        return http({
            url: '/api/swyl/v1/guanhuai/bscContactPerson/selectPage',
            method: 'post',
            params: query,
        })
    },
    downloadBatchExcelSummary(query) {
        return http({
            url: '/api/swyl/v1/mubiao/userDailyTargetSummary/downloadExcel',
            method: 'post',
            data: query,
            responseType: 'blob',
            dataType:"json",
        });
    },
    //周目标管理导出详情
    downloadBatchExcelMubiaoWeek(query) {
        return http({
            url: '/api/swyl/v1/mubiao/userDailyTarget/downloadExcelTy',
            method: 'post',
            data: query,
            responseType: 'blob',
        });
    },

    newCheckPageDayClean(query) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/newSelectPage',
            method: 'post',
            params: query
        });
    },
    checkPageDayClean(query) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/selectPage',
            method: 'post',
            params: query
        });
    },

    selectUser(date) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/selectUser?userName=' + date,
            method: 'post',
        });
    },

    dayCleanConfigInsert(query) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/insert',
            method: 'post',
            data: query
        });
    },

    newDayCleanConfigInsert(query) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/newInsert',
            method: 'post',
            data: query
        });
    },

    newDayCleanConfigSelectById(data1,data2,data3) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/newSelectById?userName=' + data1+'&userCode='+data2+'&titleCode='+data3   ,
            method: 'post',
        });
    },

    dayCleanConfigSelectById(data) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/selectById?id=' + data,
            method: 'post',
        });
    },

    newDayCleanConfigUpdateById(query) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/newUpdateById',
            method: 'post',
            data: query
        });
    },

    dayCleanConfigUpdateById(query) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/updateById',
            method: 'post',
            data: query
        });
    },

    dayCleanConfigDeleteById(data) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/deleteById?id=' + data,
            method: 'post',
        });
    },

    newDayCleanConfigDeleteById(data1,data2,data3) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/newDeleteById?id=' + data1+'&userName='+data2+'&titleCode='+data3,
            method: 'post',
        });
    },
    getFeildQudaoMap(query) {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/selectFieldQudao',
            method: 'post',
            params: query
        });
    },
    getLianqunList() {
        return http({
            url: this.baseurl2 + '/demo/bscUserDayCleanConfig/seletLiaqunList',
            method: 'get'
        });
    }

}
